import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'default',
    pure: true,
})
export class DefaultPipe implements PipeTransform {
    transform(value: unknown, defaultValue: unknown): unknown {
        return value || defaultValue;
    }
}
